/**
 * Utility for accessing the job permissions shard database.
 * @param {string} [projectId] - The Firebase project ID to construct the shard database URL for. Optional if globalThis.config.appName is set.
 * @return {string} The database URL for the job permissions shard.
 */
export function getJobPermissionsDatabaseURL(projectId) {
  const SHARD_SUFFIX = '-job-permissions';
  projectId = globalThis?.config?.appName || projectId;
  return `https://${projectId}${SHARD_SUFFIX}.firebaseio.com`;
}
